"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEditableInsightMenu = void 0;
// (C) 2021-2023 GoodData Corporation
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var dashboardContexts_1 = require("../../../dashboardContexts");
var insightMenu_1 = require("../../insightMenu");
var model_1 = require("../../../../model");
exports.useEditableInsightMenu = function (config) {
    var _a, _b;
    var insight = config.insight, widget = config.widget, closeMenu = config.closeMenu;
    var intl = react_intl_1.useIntl();
    var dispatch = model_1.useDashboardDispatch();
    var settings = model_1.useDashboardSelector(model_1.selectSettings);
    var enableKPIDashboardDrillToURL = settings.enableKPIDashboardDrillToURL, enableKPIDashboardDrillToDashboard = settings.enableKPIDashboardDrillToDashboard, enableKPIDashboardDrillToInsight = settings.enableKPIDashboardDrillToInsight;
    var configItems = model_1.useDashboardSelector(model_1.selectDrillTargetsByWidgetRef(widget.ref));
    var someDrillingEnabled = enableKPIDashboardDrillToURL ||
        enableKPIDashboardDrillToDashboard ||
        enableKPIDashboardDrillToInsight;
    var availableDrillTargets = configItems === null || configItems === void 0 ? void 0 : configItems.availableDrillTargets;
    var someAvailableDrillTargetsExist = !!((_a = availableDrillTargets === null || availableDrillTargets === void 0 ? void 0 : availableDrillTargets.attributes) === null || _a === void 0 ? void 0 : _a.length) || !!((_b = availableDrillTargets === null || availableDrillTargets === void 0 ? void 0 : availableDrillTargets.measures) === null || _b === void 0 ? void 0 : _b.length);
    var includeInteractions = someDrillingEnabled && someAvailableDrillTargetsExist;
    var insightMenuItemsProvider = dashboardContexts_1.useDashboardCustomizationsContext().insightMenuItemsProvider;
    var defaultMenuItems = react_1.useMemo(function () {
        return insightMenu_1.getDefaultInsightEditMenuItems(widget, { intl: intl, dispatch: dispatch, includeInteractions: includeInteractions });
    }, [dispatch, intl, widget, includeInteractions]);
    var menuItems = react_1.useMemo(function () {
        return insightMenuItemsProvider
            ? insightMenuItemsProvider(insight, widget, defaultMenuItems, closeMenu, "edit")
            : defaultMenuItems;
    }, [insightMenuItemsProvider, insight, widget, defaultMenuItems, closeMenu]);
    return { menuItems: menuItems };
};
//# sourceMappingURL=useEditableInsightMenu.js.map